module.exports = __webpack_public_path__ + "img/student.f86f008b.png";